// extracted by mini-css-extract-plugin
module.exports = {"welcome":"WelcomeScreen_welcome__g6FWi","header":"WelcomeScreen_header__3HTty","subheader":"WelcomeScreen_subheader__1eZjB","caption":"WelcomeScreen_caption__3UxUI"};